import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

//TODO: remove unused component

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class DesignSampleModule {
}
